module.exports = __webpack_public_path__ + "static/media/list_white.0f793758.svg";